import './styles.scss';
import { Handle, Position } from '@xyflow/react';
import { IconPlus } from '@tabler/icons-react';
import { Text } from '@fragments';

export default function AddBlockNode() {
    return (
        <div className="add-block-node">
            <Handle
                type="target"
                position={Position.Top}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <IconPlus size={16} />
            <Text.span contrast={5}>Adicionar bloco</Text.span>
        </div>
    );
}
